import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-consulta-recibos-cadetes',
  templateUrl: './consulta-recibos-cadetes.component.html',
  styleUrls: ['./consulta-recibos-cadetes.component.css']
})
export class ConsultaRecibosCadetesComponent implements OnInit {

  displayedColumns: string[] = ['id', 'date', 'comprobante', 'total', 'liquidado', 'balance', 'pdf'];
  dataSource = reciboData;

  options = [
    { value: 'empresa1', viewValue: 'Empresa 1' },
    { value: 'empresa2', viewValue: 'Empresa 2' },
    { value: 'empresa3', viewValue: 'Empresa 3' },
    { value: 'empresa4', viewValue: 'Empresa 4' },
  ];

  constructor() { }

  ngOnInit(): void {
  }

}

export interface Recibo {
  id: string,
  date: string,
  comprobante: string,
  total: string,
  liquidado: string,
  balance: string,
  pdf: string,
}

const reciboData: Recibo[] = [
  { id: 'string', date: 'string', total: 'string', comprobante: 'string', liquidado: 'string', balance: 'string', pdf: 'string' },
  { id: 'string', date: 'string', total: 'string', comprobante: 'string', liquidado: 'string', balance: 'string', pdf: 'string' },
  { id: 'string', date: 'string', total: 'string', comprobante: 'string', liquidado: 'string', balance: 'string', pdf: 'string' },
  { id: 'string', date: 'string', total: 'string', comprobante: 'string', liquidado: 'string', balance: 'string', pdf: 'string' },
  { id: 'string', date: 'string', total: 'string', comprobante: 'string', liquidado: 'string', balance: 'string', pdf: 'string' },
];